"use server";

import { API_BASE_URL, USE_MOCKS } from "@/lib/config";
import { contactFormSchema, type ContactFormValues } from "@/lib/schemas";

export type SubmitLeadResult =
  | { ok: true }
  | { ok: false; status: number; message: string };

export async function submitLead(values: ContactFormValues): Promise<SubmitLeadResult> {
  const parsed = contactFormSchema.safeParse(values);
  if (!parsed.success) {
    return { ok: false, status: 422, message: "Please check the form for errors." };
  }

  if (USE_MOCKS) {
    await new Promise((resolve) => setTimeout(resolve, 400));
    return { ok: true };
  }

  try {
    const res = await fetch(`${API_BASE_URL}/public/leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(parsed.data),
    });

    if (res.ok) return { ok: true };

    if (res.status === 429) {
      return { ok: false, status: 429, message: "Please try again shortly." };
    }

    const body = await res.json().catch(() => null);
    return {
      ok: false,
      status: res.status,
      message: body?.message ?? "Something went wrong. Please try again.",
    };
  } catch {
    return { ok: false, status: 500, message: "Something went wrong. Please try again." };
  }
}
